import React from 'react'
import {findDOMNode} from "react-dom"

import ProjectCollectionModel from "../../../../core/model2/project-collection/project-collection-model";
import NavigationSection from "../../../../core/model2/navigation/navigation-section";
import NavigationMenuItem from "../menu-item";
import {PopoverMenuItemType} from "../../../../core/gd-components/popover-menu/popover-menu/const";
import {NavigationSectionType} from "../../../../core/model2/navigation/@const";
import {BUS_APP_LAUNCH} from "../../../../core/gd/app-manager/@event"

type State = {
    selected        : boolean,
    useHint         : boolean
}

type Props = {
    portfolio           : ProjectCollectionModel
    navigationSection?  : NavigationSection
    // viewId              : ID,
    style?              : style
    dndPreview?         : any
    dndIsDragged?       : boolean
}

export default class NavigationMenuItemPortfolio extends React.Component<Props,State> {

    private debouncedCheckHint : any

    constructor(props:any) {
        super(props);

        this.state = {
            selected    : props.portfolio.isOpen,
            useHint     : false
        }

        this.debouncedCheckHint = _.debounce(this._checkHintUsage, 300);
    }

    componentDidMount() {
        gd.bus.subscribe(BUS_APP_LAUNCH, this, this.onLaunchApp);

        this.debouncedCheckHint()
    }

    componentDidUpdate() {
        this.debouncedCheckHint()
    }

    componentWillUnmount = () => {
        this.debouncedCheckHint.cancel();

        gd.bus.unsubscribe(this)
    }

    _checkHintUsage = () => {
        const useHint = gd.utils.getTextExceedsNodeWidth(this.props.portfolio.name, findDOMNode(this), 56, 14);

        if (this.state.useHint !== useHint) {
            this.setState({
                useHint: useHint
            })
        }
    }

    onLaunchApp = (params:any) => {
        // just in case
        if (!this.props.portfolio) return

        if (this.state.selected)    !this.props.portfolio.isOpen && this.setState({selected: false})
        else                        this.props.portfolio.isOpen && this.setState({selected: true})
    }

    onClick = () => this.props.portfolio.open()

    onInfo = () => {
        gd.goTo('portfolio/{0}/info'.f(this.props.portfolio.id))
    }

    onDelete = () => {
        gd.modals.portfolio.deletePortfolio(this.props.portfolio.id)
    }

    render () {
        // patch to prevent errors
        if (!this.props.portfolio) return false;

        const canDelete = !this.props.portfolio.isSharedWithMe

        const moreOptions : Option[] = [
            {
                label       : "Info",
                icon        : "ii5-information",
                disabled    : false, //!this.view.canEdit,
                onClick     : this.onInfo
            },
            {
                label       : "Delete",
                icon        : "i5-trash-alt",
                onClick     : this.onDelete,
                disabled    : !canDelete
            },
            {
                type    : PopoverMenuItemType.SEPARATOR
            },
            {
                type    : PopoverMenuItemType.HEADER,
                label   : 'Display In:'
            },
        ]

        // add display options
        _.map(this.props.portfolio.locationOptions, (option:Option) => {
            option              = _.clone(option)    // because we modify it below
            option.isSelected   = option.value === this.props.portfolio.location
            option.onClick      = () => { this.props.portfolio.location = option.value as NavigationSectionType }
            moreOptions.push(option)
        })

        const classes = Classes('portfolioId-'+this.props.portfolio.id /*required for scroll to node*/)

        return (
            <NavigationMenuItem className       = {classes}
                                name            = {this.props.portfolio.name}
                                selected        = {this.state.selected}
                                icon            = {Classes('icon ii5-assets')}
                                style           = {this.props.style}
                                dndPreview      = {this.props.dndPreview}
                                dndIsDragged    = {this.props.dndIsDragged}
                                url             = {this.props.portfolio.url}
                                moreMenuOptions = {moreOptions}
                                isShared        = {this.props.portfolio.isSharedWithMe}
                                {...this.props}
            />
        )
    }
}
